module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"axios","commonjs2":"axios","amd":"axios","root":"axios"}
// module id = 2
// module chunks = 0 1